import { render, staticRenderFns } from "./dashboard-widgets.vue?vue&type=template&id=2632838c&"
import script from "./dashboard-widgets.vue?vue&type=script&lang=js&"
export * from "./dashboard-widgets.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-widgets.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports